import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header__logo" }
const _hoisted_3 = {
  style: {"height":"50px","width":"auto"},
  id: "uuid-11ace280-15f8-4407-9bdb-82aa5e1f173e",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "531.74",
  height: "218.39",
  viewBox: "0 0 531.74 218.39"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("g", null, [
  /*#__PURE__*/_createElementVNode("g", null, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "m342.67,136.37l-11.7-32.26-12.36,32.26h24.07Zm-27.03,9.33c-3.42,10.52-9.13,27.42-9.13,27.42h-13.08l37.53-94.91h13.62l33.88,94.91h-23.66s-5.57-18.14-9.12-27.42h-30.05Z",
      fill: "#fff"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "m392.78,78.22h21.21v43.33c11.7-14.26,34.19-43.33,34.19-43.33l19.69.14s-34.08,34.19-38.68,39.32l38.04,53.57,1.24,1.98-24.23-.04-30.37-44.02.11,44.02h-21.21v-94.96Z",
      fill: "#fff"
    }),
    /*#__PURE__*/_createElementVNode("rect", {
      x: "484.81",
      y: "78.22",
      width: "19.73",
      height: "94.96",
      fill: "#fff"
    })
  ]),
  /*#__PURE__*/_createElementVNode("g", null, [
    /*#__PURE__*/_createElementVNode("polygon", {
      points: "135.72 39.55 37.27 39.55 37.27 134.54 58.52 134.54 58.52 60.68 114.59 60.68 114.59 134.6 135.72 134.6 135.72 39.55",
      fill: "#fff"
    }),
    /*#__PURE__*/_createElementVNode("polygon", {
      points: "75.99 173.2 174.44 173.2 174.44 78.2 153.19 78.2 153.19 152.06 97.12 152.06 97.12 78.14 75.99 78.14 75.99 173.2",
      fill: "#fff"
    })
  ]),
  /*#__PURE__*/_createElementVNode("polygon", {
    points: "203.57 78.18 224.79 78.23 224.79 116.8 261.25 116.8 261.25 78.23 282.48 78.2 282.48 173.16 261.25 173.19 261.26 126.13 224.79 126.13 224.79 173.19 203.57 173.14 203.57 78.18",
    fill: "#fff"
  })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "m522.23,93.36c-1.15,0-2.2-.19-3.16-.57-.96-.38-1.79-.91-2.5-1.59-.71-.68-1.26-1.49-1.65-2.41-.39-.92-.59-1.93-.59-3.02s.2-2.07.59-2.99c.39-.92.94-1.72,1.65-2.4.71-.68,1.54-1.2,2.5-1.58.96-.38,2.01-.57,3.16-.57s2.19.19,3.16.57c.97.38,1.82.9,2.53,1.58.71.68,1.27,1.48,1.67,2.4.4.92.6,1.92.6,2.99s-.2,2.09-.6,3.02c-.4.92-.96,1.72-1.67,2.41-.71.68-1.56,1.21-2.53,1.59-.97.38-2.03.57-3.16.57Zm0-1.09c1.26,0,2.4-.28,3.41-.83,1.02-.55,1.82-1.31,2.42-2.28.59-.97.89-2.08.89-3.34,0-.91-.17-1.75-.5-2.53-.34-.78-.8-1.47-1.41-2.06-.6-.59-1.31-1.05-2.13-1.38-.82-.33-1.71-.49-2.68-.49s-1.85.16-2.66.49c-.81.33-1.51.79-2.11,1.37-.6.59-1.06,1.27-1.39,2.05-.32.78-.48,1.62-.48,2.51s.16,1.76.48,2.54c.32.79.78,1.48,1.39,2.06.6.59,1.3,1.05,2.11,1.38.8.33,1.69.5,2.66.5Zm-3.4-11.11h4.1c.57,0,1.08.15,1.52.46.44.31.79.69,1.04,1.16s.38.95.38,1.45c0,.38-.07.74-.21,1.1-.14.36-.34.67-.59.94-.25.27-.55.48-.88.62l2.16,3.46h-2.25l-1.93-3.09h-1.34v3.09h-2v-9.2Zm3.93,4.45c.35,0,.63-.12.83-.36.2-.24.3-.58.3-1.01,0-.46-.12-.8-.35-1.02-.23-.22-.51-.33-.83-.33h-1.89v2.73h1.93Z",
  fill: "#fff"
}, null, -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { class: "header__list" }
const _hoisted_8 = { class: "header__list__item" }

import { useAuthStore } from '@/stores/AuthStore';
  import { useUserStore } from '@/stores/UserStore';
  import { useRouter } from 'vue-router';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props) {

  const authStore = useAuthStore();
  const userStore = useUserStore();
  const router = useRouter();

  const logout = async () => {
    await authStore.logout();
    await userStore.clear();
    await router.push({ name: 'login' });
  };

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/",
        style: {"display":"inline-flex"}
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock("svg", _hoisted_3, _hoisted_6))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("ul", _hoisted_7, [
      _createElementVNode("li", _hoisted_8, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _createTextVNode("Home")
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_el_button, { onClick: logout }, {
      default: _withCtx(() => [
        _createTextVNode("Logout")
      ]),
      _: 1
    })
  ]))
}
}

})